import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.547 7.636c.16-.012.308.05.413.155a.528.528 0 0 1 .178.42l-.19 4.417a.47.47 0 0 1-.52.448.532.532 0 0 1-.475-.552l.125-2.899-5.311 5.312a.55.55 0 0 1-.702.063l-.076-.063-3.496-3.496-6.244 6.245a.55.55 0 0 1-.842-.702l.064-.076 6.634-6.634a.55.55 0 0 1 .701-.063l.076.063 3.496 3.496 5.053-5.054-3.163.23a.526.526 0 0 1-.56-.46.476.476 0 0 1 .414-.53l.024-.002 4.401-.318z"
});

var SvgTrending = function SvgTrending(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgTrending;